module.exports = __webpack_public_path__ + "static/media/Analytics_FAKE.6f543eb3.png";